import { ServerErrorYellow } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
import {
  Button,
  Loader,
  StyledTable,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@randstad-lean-mobile-factory/react-components-core';

import { useGetAllRoutes } from 'src/Hooks/MbapiAdmin/useGetAllRoutes';

import TopBar from '../TopBar';

import styles from './MbapiAdminSection.module.scss';
import { RouteCheckbox } from './RouteCheckbox';

export const MbapiAdminSection = () => {
  const { data, isLoading, refetch } = useGetAllRoutes();

  return (
    <>
      <TopBar />
      <div className={styles.content}>
        {isLoading ? (
          <div className={styles.illustration}>
            <Loader size="large" />
            chargement en cours
          </div>
        ) : !data ? (
          <div className={styles.illustration}>
            <ServerErrorYellow />
            désolé, une erreur est survenue
            <Button size="medium" onClick={() => refetch()}>
              réessayer
            </Button>
          </div>
        ) : (
          <StyledTable size="small" color="white">
            <TableHeader>
              <TableRow color="white">
                <TableHead>route</TableHead>
                {data.users.map(username => (
                  <TableHead
                    key={username}
                    style={{ textAlign: 'center', minWidth: '60px', maxWidth: '60px' }}
                  >
                    {username}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.routes.map((route, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {route.method} {route.path}
                  </TableCell>
                  {data.users.map(username => (
                    <TableCell
                      key={username}
                      align="center"
                      style={{ minWidth: '60px', maxWidth: '60px' }}
                    >
                      <RouteCheckbox route={route} username={username} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </StyledTable>
        )}
      </div>
    </>
  );
};
